// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AbsenceFormController from "./absence_form_controller"
import AsyncButtonController from "./async_button_controller"
import CaseMessagesController from "./case_messages_controller"
import CheckboxSelectAllController from "./checkbox_select_all_controller"
import ContentLoaderController from "./content_loader_controller"
import ExpandableContentController from "./expandable_content_controller"
import FilterController from "./filter_controller"
import FlashController from "./flash_controller"
import HashHighlightController from "./hash_highlight_controller"
import HighchartController from "./highchart_controller"
import MaxHeightController from "./max_height_controller"
import MultiStepFormController from "./multi_step_form_controller"
import OnboardingActivateController from "./onboarding/activate_controller"
import OnboardingEmployeeFormController from "./onboarding/employee/form_controller"
import PersonSearchController from "./person_search_controller"
import PinScrollingToBottomController from "./pin_scrolling_to_bottom_controller"
import RangeSliderController from "./range_slider_controller"
import RevealController from "./reveal_controller"
import SortableController from "./sortable_controller"
import TabsController from "./tabs_controller"
import TextTypingAnimationController from "./text_typing_animation_controller"

application.register("absence-form", AbsenceFormController)
application.register("async-button", AsyncButtonController)
application.register("case-messages", CaseMessagesController)
application.register("checkbox-select-all", CheckboxSelectAllController)
application.register("content-loader", ContentLoaderController)
application.register("expandable-content", ExpandableContentController)
application.register("filter", FilterController)
application.register("flash", FlashController)
application.register("hash-highlight", HashHighlightController)
application.register("highchart", HighchartController)
application.register("max-height", MaxHeightController)
application.register("multi-step-form", MultiStepFormController)
application.register("onboarding-activate", OnboardingActivateController)
application.register("onboarding-employee-form", OnboardingEmployeeFormController)
application.register("person-search", PersonSearchController)
application.register("pin-scrolling-to-bottom", PinScrollingToBottomController)
application.register("range-slider", RangeSliderController)
application.register("reveal", RevealController)
application.register("sortable", SortableController)
application.register("tabs", TabsController)
application.register("text-typing-animation", TextTypingAnimationController)
